export const FERRY_PASSAGE_TRANSACTION_SERVICE_TYPE_ID = '2317'
export const INTERNATIONAL_TRANSPORT_TRANSACTION_SERVICE_TYPE_ID = '6'
export const FREIGHT_TRANSACTION_SERVICE_TYPE_ID = '2316'